<div class="createTools m-b-15">
  <div class="row justify-content-between">
    <div class="col-sm-12 col-lg-6">
      @if(canCreate || canEdit) {
      <button mat-button (click)="save()" class="saveButton" [attr.aria-label]="'save' |translate">
        <!-- <svg class="pc-icon">
          <use xlink:href="assets/fonts/custom-icon.svg#save"></use>
        </svg> -->
        <svg width="20" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path
            d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
            fill="#fff" />
        </svg>
        {{'save' | translate}}
      </button>
      }
      @if(canCreate && canEdit) {
      <button mat-button (click)="saveAndCopy()" class="saveandCopyButton" [attr.aria-label]="'saveCopy' |translate">
        <svg class="pc-icon" style="height: 15px; color:#333;">
          <use xlink:href="assets/fonts/custom-icon.svg#saveandCopy"></use>
        </svg>
        {{'saveCopy' | translate}}
      </button>
      }
      @if(canCreate || canEdit) {
      <button mat-button (click)="clear()" class="clearButton" [attr.aria-label]="'clear' |translate">
        <!-- <svg class="pc-icon">
          <use xlink:href="assets/fonts/custom-icon.svg#trash"></use>
        </svg> -->
        <svg width="15" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path
            d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
            fill="#3d3b3b" />
        </svg>
        {{'clear' | translate}}
      </button>

      }
      <button mat-button (click)="cancel()" class="cancelButton" [attr.aria-label]="'cancel' |translate">
        <!--  <svg class="pc-icon">
          <use xlink:href="assets/fonts/custom-icon.svg#addItem"></use>
        </svg> -->
        <svg width="15" height="14" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
            fill="#FF0000" />
        </svg>
        {{'cancel' | translate}}
      </button>

    </div>
    <div class="col-sm-12 col-lg-5 tools-right">

      <!-- [ngClass]="{'flex-row-reverse': !editId}" -->

      <!-- @if(editId) { -->
      <mat-form-field class="report-field report-field-inline" appearance="outline">
        <mat-label>{{'report' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedReport" name="exOption" (selectionChange)="reportNameSelect($event.value)">
          @for (report of reportsData; track report) {
          <mat-option [value]="report">{{currentLang == 'ar' ? report.reportaraname :
            report.reportlatname }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button mat-flat-button color="primary" (click)="printReport()">{{'saveandprint' |translate}}</button>

      <div class="tools-icons">
        <button mat-icon-button (click)="designReport()" [attr.aria-label]="'design' |translate" matTooltip="{{'design' | translate}}"
          class="design">
          <svg class="pc-icon" [style.color]="'#3939B6'">
            <use xlink:href="assets/fonts/custom-icon.svg#design"></use>
          </svg>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="moreMenu" [attr.aria-label]="'more' | translate"
          [matTooltip]="'more' | translate" class="more-menu-trigger">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <mat-menu #moreMenu="matMenu" (opened)="loadMenu(true, selectedOption)">
        @for (option of moreOptions; track option) {
        <button mat-menu-item (click)="optionSelect(option.value)">{{option.viewValue | translate}}</button>
        }
        @for (item of extraDynamicMenu; track item) {
        <button mat-menu-item (click)="optionSelect(item.functionName)">{{item.commandName | translate}}</button>
        }
      </mat-menu>
    </div>
    <!-- } -->
  </div>
</div>
